import { delay, put, race, select, take } from 'redux-saga/effects';
import {
  STORM_STABILITY_WINDOW_MS,
  selectConsecutiveReconnectCycles,
  signalingReconnectionStarted,
  signalingStabilized,
} from 'features/application/applicationSlice';

/**
 * Decays the reconnect-cycle counter once the connection proves stable.
 *
 * Runs on every successful (re)connection. A real reconnect storm keeps
 * reconnecting briefly between drops, so the counter must NOT reset on each
 * reconnect — that would prevent detection. Instead we wait out a stability
 * window: if a fresh reconnect starts first, the storm is ongoing and the
 * counter is left to keep climbing; only an uninterrupted window clears it.
 */
export function* resetReconnectCyclesSaga() {
  const consecutiveCycles: number = yield select(selectConsecutiveReconnectCycles);
  if (consecutiveCycles === 0) {
    return;
  }

  const { stabilized } = yield race({
    stabilized: delay(STORM_STABILITY_WINDOW_MS),
    interrupted: take(signalingReconnectionStarted),
  });

  if (stabilized) {
    yield put(signalingStabilized());
  }
}
